export default "__VITE_ASSET__Zup6gRUk__"